import http from "src/services/http";
import queryString from "query-string";
import store from "../index";
import * as types from "src/store/types/fidelidade_dashboard";

export const carregarResumoTotalizadores = () => {
  return (dispatch) => {
    http.get("/api/v2/empresa/fidelidade/dashboard/totalizadores").then(
      (resp) => {
        dispatch([
          {
            type: types.FIDELIDADE_DASHBOARD_TOTALIZADORES,
            payload: resp.data,
          },
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      }
    );
  };
};

export const carregarGraficoTransacoes = () => {
  return (dispatch) => {
    http.get("/api/v2/empresa/fidelidade/dashboard/grafico_transacoes").then(
      (resp) => {
        dispatch([
          {
            type: types.FIDELIDADE_DASHBOARD_GRAFICO_TRANSACOES,
            payload: resp.data,
          },
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      }
    );
  };
};

export const carregarDadosComparativos = () => {
  return (dispatch) => {
    http.get("/api/v2/empresa/fidelidade/dashboard/comparativos").then(
      (resp) => {
        dispatch([
          { type: types.FIDELIDADE_DASHBOARD_COMPARATIVOS, payload: resp.data },
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([
          { type: types.FIDELIDADE_DASHBOARD_LOADING, payload: false },
        ]);
      }
    );
  };
};
